import { BeconCommonTypes, Optional } from "@becon-team/becon-fe-lib/my-types";
import { BeconLogKindEnum } from "@becon-team/becon-fe-lib/services";
import type { i18n as I18n } from "i18next";

export const projectConfig = {
  project: {
    code: BeconLogKindEnum.B2C,
    kind: BeconLogKindEnum.B2C,
    name: (i18n?: I18n) => {
      switch (i18n?.languages?.[0]) {
        case "ko":
          return "위드비컨";
        default:
          return "Becon Pro.";
      }
    },
    b2c_name: (i18n?: I18n) => {
      switch (i18n?.languages?.[0]) {
        case "ko":
          return "위드비컨";
        default:
          return "withbecon";
      }
    },
  },
  company: {
    name: (i18n?: I18n) => {
      switch (i18n?.languages?.[0]) {
        case "ko":
          return "비컨";
        default:
          return "Becon";
      }
    },
    phone_number: "+82 01033507753",
    email: "service@withbecon.com",
    kakao: "https://pf.kakao.com/_QHdyb/chat",
    contact_us_link: (i18n?: I18n) => {
      switch (i18n?.languages?.[0]) {
        case "ko":
          return projectConfig.company.kakao;
        default:
          return `mailto:${projectConfig.company.email}`;
      }
    },
    community_link: "https://www.beconx.com/community",
  },
  mall_link: {
    b2c: (region: Optional<BeconCommonTypes.Region>) => {
      switch (region) {
        case "KR":
          return "https://withbecon.shop/product/list.html?cate_no=53";
        default:
          return "https://www.amazon.com/stores/WithBecon/page/F60DC295-C848-4168-99EC-95C23373C694?ref_=ast_bln";
      }
    },
    b2c_shampoo: (region: Optional<BeconCommonTypes.Region>) => {
      switch (region) {
        case "KR":
          return "https://pf.kakao.com/_WxjsAs";
        default:
          return "https://www.beconx.com/solution-matching";
      }
    },
    logo_brand: (region: Optional<BeconCommonTypes.Region>) => {
      switch (region) {
        case "KR":
          return `https://becon.store/surl/O/93`;
        default:
          return `https://www.globalbecon.com/collections/customization/products/software-brand-page-customization`;
      }
    },
    product_solution: (region: Optional<BeconCommonTypes.Region>) => {
      switch (region) {
        case "KR":
          return `https://becon.store/surl/O/95`;
        default:
          return `https://www.globalbecon.com/collections/customization/products/becon-product-customization`;
      }
    },
    treat_solution: (region: Optional<BeconCommonTypes.Region>) => {
      switch (region) {
        case "KR":
          return `https://becon.store/surl/O/94`;
        default:
          return `https://www.globalbecon.com/collections/customization/products/becon-product-customization`;
      }
    },
  },
  app_link: {
    download: "https://onelink.to/37vujk",
    b2c: {
      app_store: "https://apps.apple.com/kr/app/%EC%9C%84%EB%93%9C%EB%B9%84%EC%BB%A8/id1554801393",
      google_play: "https://play.google.com/store/apps/details?id=com.with.becon&hl=ko-KR&pli=1",
    },
  },
  app_update_link: (lng: string) => {
    switch (lng) {
      case "ko":
        return "a400e3b9f81e471b9faec0856487588a?pvs=4";
      default:
        return "Update-History-9a3353bedef8437daef8496639d8db6a";
    }
  },
  notion: {
    guide: {
      scanner_capture: (lng: string) => {
        switch (lng) {
          case "ko":
            return "2ec152a5230942cf96827dabef8e3d84";
          default:
            return "Scanner-Image-Capture-Guide-5b1fd63e534a4d29ae55a7b63a2325ac";
        }
      },
      precision_hair_loss: (lng: string) => {
        switch (lng) {
          case "ko":
            return "2bfcf9b1a62c4c1689852b7d1652c0af";
          default:
            return "How-to-use-Precision-Hair-loss-Analysis-Important-ab06c6d80e7649a9bc7dece2c006d375";
        }
      },
    },
    term: {
      all: (lng: string) => {
        switch (lng) {
          case "ko":
            return "2f4de0d834f94f70a836cffc773be44d";
          case "ja":
            return "d02269685e004bb8a612e4f05b92c99a";
          default:
            return "Terms-54b3679b7f60498a9964d5516952be71?pvs=74";
        }
      },
      service: (lng: string) => {
        switch (lng) {
          case "ko":
            return "4b295319018e4e95a956383939f7ee96";
          case "ja":
            return "d02269685e004bb8a612e4f05b92c99a";
          default:
            return "Consent-to-Service-Usage-bbcd02e8ab374c8f967dc62957cb3164";
        }
      },
      privacy: (lng: string) => {
        switch (lng) {
          case "ko":
            return "272e55f6492d4aa38959d714186bfc2a";
          case "ja":
            return "d02269685e004bb8a612e4f05b92c99a";
          default:
            return "Consent-to-Collect-and-Use-Personal-Information-e0558597ce7746eeb625808a52af4ea7";
        }
      },
      sensitivity: (lng: string) => {
        switch (lng) {
          case "ko":
            return "552f827f367f4b61aa8878cc326d2d60";
          case "ja":
            return "d02269685e004bb8a612e4f05b92c99a";
          default:
            return "Consent-to-Collect-and-Use-Sensitive-Information-dd37091bc99c4d89a74b95c80ad0211b";
        }
      },
      marketing: (lng: string) => {
        switch (lng) {
          case "ko":
            return "5d9b5c2027b6425798fee0c506c96112";
          case "ja":
            return "d02269685e004bb8a612e4f05b92c99a";
          default:
            return "Marketing-Opt-in-b21a833e209f455498b640a847234cef";
        }
      },
    },
  },
  app_version_check: {
    noMoreUpdateModal: {
      androidVersion: "2.0.4",
      iosVersion: "2.1.0",
    },
  },
} as const;
